import { getRuntimeEnv } from "~/utils/getRuntimeEnv";

const runtimeEnv = getRuntimeEnv();

export const SANITY_PROJECT_ID = runtimeEnv?.VITE_SANITY_PROJECT_ID;
export const SANITY_DATASET = runtimeEnv?.VITE_SANITY_DATASET;
export const SANITY_API_VERSION = runtimeEnv?.VITE_SANITY_API_VERSION;

/** In-memory SSR TTLs for published Sanity reads (per Node process). */
export const SANITY_CACHE_TTL_MS = {
  /** Insights index HTML is edge-cached ~300s; 90s keeps SSR pods warm. */
  insightsIndex: 90_000,
  /** Shared across category / type / tag listing pages. */
  insightsSidebar: 90_000,
  /** Dashboard highlights row — high traffic. */
  latestInsight: 60_000,
  /** Published article pages. */
  insightBySlug: 90_000,
  /** RSS feed (also has edge Cache-Control). */
  insightsFeed: 90_000,
  /**
   * Catch-all CMS page lookups, including misses. Bots and infrastructure
   * probes hammer the same unmatched paths, so caching the "no such page"
   * answer is what keeps a 404 from costing a Sanity request every time.
   */
  pageBySlug: 300_000,
  /** Footer links toggled on in the CMS; every document request renders them. */
  footerLinks: 300_000,
} as const;

export const SANITY_CACHE_KEYS = {
  insightsIndex: "sanity:insights-index",
  insightsSidebar: "sanity:insights-sidebar",
  latestInsight: "sanity:latest-insight",
  insightBySlug: (slug: string) => `sanity:insight:${slug}`,
  insightsFeed: "sanity:insights-feed",
  pageBySlug: (slug: string) => `sanity:page:${slug}`,
  footerLinks: "sanity:footer-links",
} as const;
